import React, { useEffect, useState } from 'react';
import moment from 'moment'
import HelpIcon from '@mui/icons-material/Help';
import EditIcon from '@mui/icons-material/Edit';
import { AccessControl } from '../../components/Utils/AccessControl'
import CircleIcon from '@mui/icons-material/Circle';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import {
  Backdrop,
  Box,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  FormLabel,
  Grid,
  Input,
  IconButton,
  Paper,
  Skeleton,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Table,
  TableContainer,
  Typography,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button
} from '@mui/material'
import { uploadFile } from '_services'
import { ordemServicoCobrancaAction, authActions, empenhoAction, ordemServicoAction } from '../../_actions';
import { connect, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useConfirm } from 'material-ui-confirm'
import { withRouter, } from 'react-router-dom'
import { withStyles } from '@mui/styles'
import CustomButton from '../../components/CustomButton/CustomButton'
import { STATUS_SERVICO, history, MANUAIS_CATEGORIAS } from '../../utils'
import CardTableFinanceiro from './cardTableFinanceiro.component';
import { HelpModal } from '../../components';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2)
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlgin: 'center'
  },
  nome: {
    marginTop: theme.spacing(1)
  },
  uploadButton: {
    marginRight: theme.spacing(2),
    justifyContent: 'center'
  },
  avatar: {
    height: 200,
    width: 200,
    borderRadius: '10px',
    webkitBorderRadius: '10px',
    mozBorderRadius: '10px',
    cursor: 'pointer'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
})

const OrdemServicoFinanceiroEdit = ({ props, idOrdemServico, ordemServico }) => {

  const { isLoading } = props.ordemServicoCobranca;
  const confirm = useConfirm()
  const dispatch = useDispatch();
  const { classes } = props

  const { ordemServicoCobranca } = props.ordemServicoCobranca;

  const { match: { params } } = props;

  const { idOrgao } = useSelector(
    (state) => state.usuarioOrgao
  )

  const [ready, setReady] = React.useState(false);

  const empenhos = useSelector((state) => state.ordemServico?.ordensServicosEmpenhos)

  const [openComprovante, setOpenComprovante] = useState(false)
  const [pagarCobranca, setPagarCobranca] = useState(false)
  const [pagarEmpenho, setPagarEmpenho] = useState(false)
  const [idCobranca, setIdCobranca] = useState(null)
  const [idEmpenho, setIdEmpenho] = useState(null)

  const [openNf, setOpenNf] = useState(false)
  const [modalHelp, setModalHelp] = useState(false);
  const toggleModalHelp = () => setModalHelp(!modalHelp);

  const handleOpenModalHelp = () => {
    toggleModalHelp();
  }

  const [openEditValor, setOpenEditValor] = useState(false);
  const [editType, setEditType] = useState(''); // 'cobranca' ou 'empenho'
  const [editId, setEditId] = useState(null);
  const [valorInput, setValorInput] = useState('');

  const handleOpenEditValor = (type, id, valorAtual) => {
    setEditType(type);
    setEditId(id);
    setValorInput(valorAtual.toString().replace('.', ','));
    setOpenEditValor(true);
  };

  const handleSaveEditValor = () => {
    const valorNumerico = parseFloat(valorInput.replace(/\./g, '').replace(',', '.'));
    if (isNaN(valorNumerico) || valorNumerico <= 0) {
      alert('Informe um valor válido maior que zero');
      return;
    }

    if (editType === 'cobranca') {
      const cob = ordemServicoCobranca.find(c => c.id === editId);
      if (cob) {
        dispatch(ordemServicoCobrancaAction.editOrdemServicoCobrancaInfo(editId, {
          ...cob,
          valor: valorNumerico
        })).then(() => {
          setOpenEditValor(false);
          let filterModel = {
            IdOrdemServico: idOrdemServico
          };
          dispatch(ordemServicoCobrancaAction.getOrdemServicoCobranca(filterModel));
        });
      }
    } else if (editType === 'empenho') {
      const emp = empenhos.find(e => e.empenho.id === editId);
      if (emp) {
        dispatch(empenhoAction.editEmpenhoInfo(editId, {
          ...emp.empenho,
          valor: valorNumerico,
          noRedirect: true
        })).then(() => {
          setOpenEditValor(false);
          dispatch(ordemServicoAction.getOrdemServicoById(idOrdemServico));
        });
      }
    }
  };

  const handleRemoveCobrancaFile = (cobranca, field) => {
    confirm({
      title: 'Você deseja remover este arquivo da Cobrança?',
      description: 'Essa operação é irreversível e alterará o status para EM ABERTO caso seja o comprovante.',
      confirmationText: 'Sim, remover!',
      cancellationText: 'Não!',
    }).then(() => {
      const payload = {
        ...cobranca,
        [field]: null
      };
      dispatch(ordemServicoCobrancaAction.editOrdemServicoCobrancaInfo(cobranca.id, payload))
        .then(() => {
          let filterModel = {
            IdOrdemServico: idOrdemServico
          };
          dispatch(ordemServicoCobrancaAction.getOrdemServicoCobranca(filterModel));
        });
    });
  };

  const handleRemoveEmpenhoFile = (empenho, field) => {
    confirm({
      title: 'Você deseja remover este arquivo do Empenho?',
      description: 'Essa operação é irreversível e alterará o status para EM ABERTO caso seja a Nota Fiscal.',
      confirmationText: 'Sim, remover!',
      cancellationText: 'Não!',
    }).then(() => {
      const payload = {
        ...empenho,
        [field]: null,
        noRedirect: true
      };
      dispatch(empenhoAction.editEmpenhoInfo(empenho.id, payload))
        .then(() => {
          dispatch(ordemServicoAction.getOrdemServicoById(idOrdemServico));
        });
    });
  };

  useEffect(() => {
    if (pagarCobranca && idCobranca) {
      realizarPagamentoCobranca()
    }
  }, [props.ordemServicoCobranca.caminhoComprovantePagamento, pagarCobranca]);

  useEffect(() => {
    if (pagarEmpenho && idEmpenho) {
      realizarPagamentoEmpenho()
    }
  }, [props.empenho.caminhoNotaFiscal, pagarEmpenho]);

  const verifyObraHasEmpenho = () => {
    return empenhos?.some(ts => ts.idOrdemServico == parseInt(idOrdemServico) && ts.excluido != true);
  }

  useEffect(() => {

  }, [ready, isLoading])

  useEffect(() => {
    //limpar todos os dados ao carregar a tela
    dispatch(ordemServicoCobrancaAction.clear())
    dispatch(empenhoAction.clear())
    setPagarCobranca(false);
    setPagarEmpenho(false);
    setIdCobranca(null)
    setIdEmpenho(null)
  }, [])

  useEffect(() => {
    if (authActions.isEmpresa()) {
      if (props.authentication.user.usuariosEmpresas[0].idEmpresa != null && props.authentication.user.usuariosEmpresas[0].idEmpresa != '') {
        let filterModel = {
          IdOrdemServico: idOrdemServico,
          IdEmpresa: props.authentication.user.usuariosEmpresas[0].idEmpresa
        };

        dispatch(ordemServicoCobrancaAction.getOrdemServicoCobranca(filterModel))
      }
    }
  }, [])

  useEffect(() => {
    let filterModel = {
      IdOrdemServico: idOrdemServico
    };

    dispatch(ordemServicoCobrancaAction.getOrdemServicoCobranca(filterModel))

  }, [])

  const handleUploadComprovante = (e) => {
    setOpenComprovante(true)
    var file = e.target.files[0]
    if (file) {
      uploadFile(file)
        .then((response) => {
          var event2 = {
            type: 'select',
            target: {
              value: response.toString()
            }
          };
          dispatch(ordemServicoCobrancaAction.onChangeProps('caminhoComprovantePagamento', event2))
          setOpenComprovante(false)
        })
        .catch((err) => {
          console.log(err)
          setOpenComprovante(false)
        })
    }
  }

  const handleUploadNotaFiscal = (e) => {
    setOpenNf(true)
    var file = e.target.files[0]
    if (file) {
      uploadFile(file)
        .then((response) => {
          var event2 = {
            type: 'select',
            target: {
              value: response.toString()
            }
          };
          dispatch(empenhoAction.onChangeProps('caminhoNotaFiscal', event2))
          setOpenNf(false)
        })
        .catch((err) => {
          console.log(err)
          setOpenNf(false)
        })
    }
  }

  const isItemPaid = (id) => {
    if (id != undefined) {
      return ordemServicoCobranca?.some((n) => n.dataPagamento != null && n.id == id)
    }
  }

  const totalPagoFinanceiro = ordemServicoCobranca?.reduce((total, item) => {
    if (item.dataPagamento) {
      return total + item.valor;
    }
    return total;
  }, 0);

  const isEmpenhoPaid = () => {
    if (empenhos) {
      return empenhos?.some((n) => n.empenho?.dataPagamento != null && n.idOrdemServico == parseInt(idOrdemServico) && n.excluido != true)
    }
  }

  const totalEmAbertoFinanceiro = ordemServicoCobranca?.reduce((total, item) => {
    if (!item.dataPagamento) {
      return total + item.valor;
    }
    return total;
  }, 0);

  const totalCobrancasEmitidasFinanceiro = ordemServicoCobranca?.reduce((total, item) => {
    if (item) {
      return total + item.valor;
    }
    return total;
  }, 0);

  const handleOpenVisualiza = (link) => {
    window.open(link, '_blank');
  }

  const handleRealizaPagamento = (id) => {
    confirm({
      title: 'Você deseja realizar o pagamento desta Cobrança?',
      description: returnUploadComprovante(),
      disabled: props.ordemServicoCobranca.isLoading,
      confirmationText: props.ordemServicoCobranca.isLoading ? 'Realizando pagamento...' : 'Sim, pagar!',
      cancellationText: 'Não!',
    }).then(() => {
      setPagarCobranca(true)
      setIdCobranca(id)
    });
  };

  const realizarPagamentoCobranca = () => {
    if (idCobranca && idCobranca != 0) {
      dispatch(ordemServicoCobrancaAction.editOrdemServicoCobrancaPaga(idCobranca, idOrdemServico, {
        caminhoComprovantePagamento: props.ordemServicoCobranca.caminhoComprovantePagamento
      }));
    }
  }

  const realizarPagamentoEmpenho = () => {
    if (idEmpenho && idEmpenho != 0) {
      dispatch(empenhoAction.editEmpenhoRealizaPagamento(idEmpenho, idOrgao, idOrdemServico, {
        caminhoNotaFiscal: props.empenho.caminhoNotaFiscal
      }));
    }
  }

  function returnUploadComprovante() {
    return (
      <Grid container spacing={2}>
        <Grid item lg={12} md={12} xl={12} xs={12} align="left">
          <Backdrop className={classes.backdrop} open={openComprovante}>
            <Grid
              container
              spacing={3}
              direction="column"
              justifyContent="center"
              alignItems="center"
              alignContent="center"
              wrap="nowrap"
            >
              <Grid item>
                <CircularProgress color="primary" />
              </Grid>
              <Grid item>
                <Typography variant="h4" color="textPrimary">
                  Enviando comprovante de pagamento...
                </Typography>
              </Grid>
            </Grid>
          </Backdrop>
          <FormLabel component="legend">Enviar Comprovante de Pagamento</FormLabel>
          <Input
            id="caminhoComprovantePagamento"
            className={classes.textField}
            label="Arquivo do comprovante"
            onChange={handleUploadComprovante}
            type="file"
            placeholder="Enviar Comprovante de Pagamento"
            formControl
            margin="dense"
          />

        </Grid>
      </Grid>
    )
  }

  const handleRealizaPagamentoEmpenho = (id) => {
    confirm({
      title: 'Você deseja marcar este empenho como pago?',
      description: returnUploadNF(),
      disabled: props.empenho.isLoading,
      confirmationText: props.empenho.isLoading ? 'Marcando como pago...' : 'Sim!',
      cancellationText: 'Não!'
    }).then(() => {
      setPagarEmpenho(true)
      setIdEmpenho(id)
    })
  }

  function returnUploadNF() {
    return (
      <Grid container spacing={2}>
        <Grid item lg={12} md={12} xl={12} xs={12} align="left">
          <Backdrop className={classes.backdrop} open={openNf}>
            <Grid
              container
              spacing={3}
              direction="column"
              justifyContent="center"
              alignItems="center"
              alignContent="center"
              wrap="nowrap"
            >
              <Grid item>
                <CircularProgress color="primary" />
              </Grid>
              <Grid item>
                <Typography variant="h4" color="textPrimary">
                  Enviando nota fiscal...
                </Typography>
              </Grid>
            </Grid>
          </Backdrop>
          <FormLabel component="legend">Enviar Nota Fiscal</FormLabel>
          <Input
            id="caminhoNotaFiscal"
            className={classes.textField}
            label="Arquivo da NF"
            onChange={handleUploadNotaFiscal}
            type="file"
            placeholder="Enviar nota fiscal"
            formControl
            margin="dense"
          />
        </Grid>
      </Grid>
    )
  }


  function TitleText() {
    return (
      <Typography variant="h5">
        <b>{'Cobranças'}</b>
      </Typography>
    )
  }
  function SegHeader() {
    return (
      <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
        <TitleText />
      </Box>
    )
  }

  function TitleTextEmpenho() {
    return (
      <Typography variant="h5">
        <b>{'Empenho'}</b>
      </Typography>
    )
  }
  function SegHeaderEmpenho() {
    return (
      <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
        <TitleTextEmpenho />
      </Box>
    )

  }

  return (
    <>
      <Grid container spacing={2} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 5, alignContent: 'center', marginTop: 3 }}>
        <Grid alignItems="center" container justifyContent="center" spacing={3} style={{ marginBottom: 15 }}>
          <Grid item lg={6} sm={6} xl={6} xs={12}>
            <CardTableFinanceiro
              //se não tiver cobrança ainda
              valorEmAberto={`R$ ${ordemServicoCobranca?.length == 0 ?
                //pega o valor do orçamento que foi aprovado
                (ordemServico?.ordensServicosOrcamentos && ordemServico?.ordensServicosOrcamentos.length > 0) ?
                  (ordemServico?.ordensServicosOrcamentos.find(orc => orc.statusOrcamento === 1)?.valor ?? 0)
                    .toLocaleString('pt-br', { minimumFractionDigits: 2 }) :
                  //senão, pega o valor das cobranças que já foram emitidas pela empresa
                  (totalEmAbertoFinanceiro != 0 && totalEmAbertoFinanceiro != undefined) ?
                    totalEmAbertoFinanceiro.toLocaleString('pt-br', { minimumFractionDigits: 2 }) :
                    '0,00' :
                (totalEmAbertoFinanceiro != 0 && totalEmAbertoFinanceiro != undefined) ?
                  totalEmAbertoFinanceiro?.toLocaleString('pt-br', { minimumFractionDigits: 2 }) :
                  '0,00'}`}
              valorTotal={totalCobrancasEmitidasFinanceiro == 0 ? 'R$ 0,00' : `R$ ${totalCobrancasEmitidasFinanceiro?.toLocaleString('pt-br', { minimumFractionDigits: 2 })}`}
              valorPago={`R$ ${totalPagoFinanceiro ? totalPagoFinanceiro?.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : '0,00'}`}
              textValorTotal="Valor total das cobranças emitidas"
              title="RESUMO FINANCEIRO"
            />
          </Grid>
          {(authActions.isGestor() || authActions.isPrefeitura()) && (
            <Grid item lg={6} sm={6} xl={6} xs={12}>
              <CardTableFinanceiro
                valorEmAberto={!verifyObraHasEmpenho() ? 'R$ --,--' : !isEmpenhoPaid() ? `R$ ${totalCobrancasEmitidasFinanceiro?.toLocaleString('pt-br', { minimumFractionDigits: 2 })}` : 'R$ 0,00'}
                valorTotal={!verifyObraHasEmpenho() ? 'R$ --,--' : `R$ ${totalCobrancasEmitidasFinanceiro?.toLocaleString('pt-br', { minimumFractionDigits: 2 })}`}
                valorPago={!verifyObraHasEmpenho() ? 'R$ --,--' : isEmpenhoPaid() ? `R$ ${totalCobrancasEmitidasFinanceiro?.toLocaleString('pt-br', { minimumFractionDigits: 2 })}` : 'R$ 0,00'}
                textValorTotal="Valor total do empenho"
                title="RESUMO EMPENHO"
              />
            </Grid>
          )}
        </Grid>
        <Card variant="outlined" sx={{ borderRadius: 2, mb: 4, overflow: 'hidden', borderLeft: '6px solid #475569', width: '100%' }}>
          <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
            <TableContainer component={Paper} elevation={0}>
              <Table>
                <TableHead>
                  <TableRow style={{ backgroundColor: '#f8fafc' }}>
                    <TableCell colSpan={7}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1 }}>
                        <Box>
                          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                            Relação de cobranças emitidas pela empresa
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <IconButton
                            aria-label="Ajuda"
                            component="a"
                            onClick={() => handleOpenModalHelp()}
                            size="small"
                          >
                            <Tooltip title={'Ajuda'}>
                              <HelpIcon sx={{ color: '#64748b' }} fontSize='medium' />
                            </Tooltip>
                          </IconButton>
                          {((authActions.isEmpresa() || authActions.isGestor()) && ((ordemServico.ultimoEvento == STATUS_SERVICO.VERIFICADO) || ordemServico.ultimoEvento == STATUS_SERVICO.AVALIADO || ordemServico.ultimoEvento == STATUS_SERVICO.CONCLUIDO)) && (
                            <CustomButton
                              size="small"
                              variant="outlined"
                              sx={{ borderColor: '#475569', color: '#475569', '&:hover': { bgcolor: '#f1f5f9' } }}
                              onClick={() => history.push(`/ordemServicoCobranca/`, idOrdemServico)}
                              endIcon={<MonetizationOnIcon />}
                            >
                              Nova cobrança
                            </CustomButton>
                          )}
                        </Box>
                      </Box>
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ backgroundColor: '#f1f5f9' }}>
                    <TableCell sx={{ fontWeight: 'bold', color: '#475569' }}>DATA</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#475569' }}>EMPRESA</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#475569' }} align="center">NOTA FISCAL</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#475569' }} align="center">COMPROVANTE PAGAMENTO</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#475569' }} align="center">VALOR</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#475569' }} align="center">STATUS</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#475569' }} align="center">AÇÕES</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ordemServicoCobranca && undefined !== ordemServicoCobranca && ordemServicoCobranca.length
                    ? ordemServicoCobranca.map((n) => {
                      return (
                        <TableRow hover key={n.id}>
                          <TableCell component="th" scope="row">
                            {n.dataCobranca ? moment(n.dataCobranca).format("DD/MM/YYYY HH:mm") : ''}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {n.empresa ? n.empresa.razaoSocial.toUpperCase() : ''}
                          </TableCell>
                          <TableCell component="th" scope="row" align="center">
                            {n.caminhoNota ?
                              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                <Chip
                                  icon={<InsertDriveFileOutlinedIcon />}
                                  label="Visualizar NF"
                                  onClick={() => handleOpenVisualiza(n.caminhoNota)}
                                  clickable
                                  variant="outlined"
                                  size="small"
                                  sx={{ borderColor: '#475569', color: '#475569', '&:hover': { bgcolor: '#f1f5f9' } }}
                                />
                                {authActions.isGestor() && (
                                  <Button
                                    variant="text"
                                    color="error"
                                    sx={{ textTransform: 'none', fontSize: '0.65rem', py: 0, minWidth: 'auto' }}
                                    onClick={() => handleRemoveCobrancaFile(n, 'caminhoNota')}
                                  >
                                    Remover NF
                                  </Button>
                                )}
                              </Box>
                              :
                              '-'}
                          </TableCell>
                          <TableCell component="th" scope="row" align="center">
                            {n.caminhoComprovantePagamento ?
                              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                <Chip
                                  icon={<AttachFileIcon />}
                                  label="Visualizar Comp."
                                  onClick={() => handleOpenVisualiza(n.caminhoComprovantePagamento)}
                                  clickable
                                  variant="outlined"
                                  size="small"
                                  sx={{ borderColor: '#475569', color: '#475569', '&:hover': { bgcolor: '#f1f5f9' } }}
                                />
                                {authActions.isGestor() && (
                                  <Button
                                    variant="text"
                                    color="error"
                                    sx={{ textTransform: 'none', fontSize: '0.65rem', py: 0, minWidth: 'auto' }}
                                    onClick={() => handleRemoveCobrancaFile(n, 'caminhoComprovantePagamento')}
                                  >
                                    Remover Comprovante
                                  </Button>
                                )}
                              </Box>
                              :
                              '-'}
                          </TableCell>
                          <TableCell component="th" scope="row" align="center">
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                                {n.valor ? 'R$ ' + n.valor.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : ''}
                              </Typography>
                              {authActions.isGestor() && (
                                <IconButton
                                  size="small"
                                  sx={{ ml: 0.5 }}
                                  onClick={() => handleOpenEditValor('cobranca', n.id, n.valor)}
                                >
                                  <Tooltip title="Editar valor">
                                    <EditIcon fontSize="small" sx={{ color: '#475569' }} />
                                  </Tooltip>
                                </IconButton>
                              )}
                            </Box>
                          </TableCell>
                          <TableCell component="th" scope="row" align="center">
                            {n.dataPagamento == null ? (
                              <Chip
                                label="EM ABERTO"
                                size="small"
                                sx={{
                                  bgcolor: '#fde8e8',
                                  color: '#9b1c1c',
                                  fontWeight: 'bold',
                                  fontSize: '0.7rem',
                                  border: '1px solid #f8b4b4'
                                }}
                              />
                            ) : (
                              <Tooltip title={`Pago em ${moment(n.dataPagamento).format("DD/MM/YYYY HH:mm")}`}>
                                <Chip
                                  label={`PAGO EM ${moment(n.dataPagamento).format("DD/MM/YYYY HH:mm")}`}
                                  size="small"
                                  sx={{
                                    bgcolor: '#e8f5e9',
                                    color: '#2e7d32',
                                    fontWeight: 'bold',
                                    fontSize: '0.7rem',
                                    border: '1px solid #c8e6c9'
                                  }}
                                />
                              </Tooltip>
                            )}
                          </TableCell>
                          <TableCell component="th" scope="row" align="center">
                            <AccessControl
                              rule={'ordensServicosCobrancas.pay'}
                              yes={() => (
                                <Checkbox
                                  onClick={() => handleRealizaPagamento(n.id)}
                                  color="primary"
                                  size="small"
                                  disabled={isItemPaid(n.id)}
                                  checked={isItemPaid(n.id)}
                                />
                              )}
                            />
                          </TableCell>
                        </TableRow >
                      )
                    })
                    :
                    (
                      !isLoading ?
                        <TableRow>
                          <TableCell rowSpan={3} colSpan={7} align="center" sx={{ py: 3, color: '#666', fontStyle: 'italic' }}>
                            Nenhuma cobrança emitida para exibir.
                          </TableCell>
                        </TableRow>
                        :
                        Array.apply(null, { length: 5 }).map((e, i) => (
                          <TableRow hover key={i}>
                            <TableCell component="th" scope="row"><Skeleton animation="wave" /></TableCell>
                            <TableCell component="th" scope="row"><Skeleton animation="wave" /></TableCell>
                            <TableCell component="th" scope="row"><Skeleton animation="wave" /></TableCell>
                            <TableCell component="th" scope="row"><Skeleton animation="wave" /></TableCell>
                            <TableCell component="th" scope="row"><Skeleton animation="wave" /></TableCell>
                            <TableCell component="th" scope="row"><Skeleton animation="wave" /></TableCell>
                            <TableCell component="th" scope="row"><Skeleton animation="wave" /></TableCell>
                          </TableRow>
                        ))
                    )
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>

        {(authActions.isGestor() || authActions.isPrefeitura()) && (
          <Card variant="outlined" sx={{ borderRadius: 2, mb: 4, overflow: 'hidden', borderLeft: '6px solid #64748b', width: '100%', mt: 3 }}>
            <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
              <TableContainer component={Paper} elevation={0}>
                <Table>
                  <TableHead>
                    <TableRow style={{ backgroundColor: '#f8fafc' }}>
                      <TableCell colSpan={6}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1 }}>
                          <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                              Informações do empenho desta Ordem de Serviço
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                    <TableRow style={{ backgroundColor: '#f1f5f9' }}>
                      <TableCell sx={{ fontWeight: 'bold', color: '#475569' }}>DATA</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', color: '#475569' }} align="center">NOTA FISCAL</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', color: '#475569' }} align="center">EMPENHO</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', color: '#475569' }} align="center">VALOR</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', color: '#475569' }} align="center">STATUS</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', color: '#475569' }} align="center">AÇÕES</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {empenhos && undefined !== empenhos && empenhos.length
                      ? empenhos.map((n) => {
                        return (
                          <TableRow hover key={n.id}>
                            <TableCell component="th" scope="row">
                              {n.empenho.dataCadastro ? moment(n.empenho.dataCadastro).format("DD/MM/YYYY HH:mm") : ''}
                            </TableCell>
                            <TableCell component="th" scope="row" align="center">
                              {n.empenho.caminhoNotaFiscal ?
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                  <Chip
                                    icon={<InsertDriveFileOutlinedIcon />}
                                    label="Visualizar NF"
                                    onClick={() => handleOpenVisualiza(n.empenho.caminhoNotaFiscal)}
                                    clickable
                                    variant="outlined"
                                    size="small"
                                    sx={{ borderColor: '#64748b', color: '#64748b', '&:hover': { bgcolor: '#f1f5f9' } }}
                                  />
                                  {authActions.isGestor() && (
                                    <Button
                                      variant="text"
                                      color="error"
                                      sx={{ textTransform: 'none', fontSize: '0.65rem', py: 0, minWidth: 'auto' }}
                                      onClick={() => handleRemoveEmpenhoFile(n.empenho, 'caminhoNotaFiscal')}
                                    >
                                      Remover NF
                                    </Button>
                                  )}
                                </Box>
                                :
                                '-'}
                            </TableCell>
                            <TableCell component="th" scope="row" align="center">
                              {n.empenho.caminhoArquivo ?
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                  <Chip
                                    icon={<AttachFileIcon />}
                                    label="Visualizar Emp."
                                    onClick={() => handleOpenVisualiza(n.empenho.caminhoArquivo)}
                                    clickable
                                    variant="outlined"
                                    size="small"
                                    sx={{ borderColor: '#64748b', color: '#64748b', '&:hover': { bgcolor: '#f1f5f9' } }}
                                  />
                                  {authActions.isGestor() && (
                                    <Button
                                      variant="text"
                                      color="error"
                                      sx={{ textTransform: 'none', fontSize: '0.65rem', py: 0, minWidth: 'auto' }}
                                      onClick={() => handleRemoveEmpenhoFile(n.empenho, 'caminhoArquivo')}
                                    >
                                      Remover Empenho
                                    </Button>
                                  )}
                                </Box>
                                :
                                '-'}
                            </TableCell>
                            <TableCell component="th" scope="row" align="center">
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                                  R$ {(n.empenho.valor != null ? n.empenho.valor : totalCobrancasEmitidasFinanceiro)?.toLocaleString('pt-br', { minimumFractionDigits: 2 })}
                                </Typography>
                                {authActions.isGestor() && (
                                  <IconButton
                                    size="small"
                                    sx={{ ml: 0.5 }}
                                    onClick={() => handleOpenEditValor('empenho', n.empenho.id, n.empenho.valor != null ? n.empenho.valor : totalCobrancasEmitidasFinanceiro || 0)}
                                  >
                                    <Tooltip title="Editar valor">
                                      <EditIcon fontSize="small" sx={{ color: '#64748b' }} />
                                    </Tooltip>
                                  </IconButton>
                                )}
                              </Box>
                            </TableCell>
                            <TableCell component="th" scope="row" align="center">
                              {n.empenho.dataPagamento == null ? (
                                <Chip
                                  label="EM ABERTO"
                                  size="small"
                                  sx={{
                                    bgcolor: '#fde8e8',
                                    color: '#9b1c1c',
                                    fontWeight: 'bold',
                                    fontSize: '0.7rem',
                                    border: '1px solid #f8b4b4'
                                  }}
                                />
                              ) : (
                                <Tooltip title={`Pago em ${moment(n.empenho.dataPagamento).format("DD/MM/YYYY HH:mm")}`}>
                                  <Chip
                                    label={`PAGO EM ${moment(n.empenho.dataPagamento).format("DD/MM/YYYY HH:mm")}`}
                                    size="small"
                                    sx={{
                                      bgcolor: '#e8f5e9',
                                      color: '#2e7d32',
                                      fontWeight: 'bold',
                                      fontSize: '0.7rem',
                                      border: '1px solid #c8e6c9'
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </TableCell>
                            <TableCell align="center">
                              <AccessControl
                                rule={'empenhos.pay'}
                                yes={() => (
                                  <Checkbox
                                    onClick={() => handleRealizaPagamentoEmpenho(n.empenho.id)}
                                    color="primary"
                                    size="small"
                                    disabled={isEmpenhoPaid(n.empenho.id)}
                                    checked={isEmpenhoPaid(n.empenho.id)}
                                  />
                                )}
                              />
                            </TableCell>
                          </TableRow >
                        )
                      })
                      :
                      (
                        !isLoading ?
                          <TableRow>
                            <TableCell rowSpan={3} colSpan={6} align="center" sx={{ py: 3, color: '#666', fontStyle: 'italic' }}>
                              Nenhum empenho encontrado.
                            </TableCell>
                          </TableRow>
                          :
                          Array.apply(null, { length: 5 }).map((e, i) => (
                            <TableRow hover key={i}>
                              <TableCell component="th" scope="row"><Skeleton animation="wave" /></TableCell>
                              <TableCell component="th" scope="row"><Skeleton animation="wave" /></TableCell>
                              <TableCell component="th" scope="row"><Skeleton animation="wave" /></TableCell>
                              <TableCell component="th" scope="row"><Skeleton animation="wave" /></TableCell>
                              <TableCell component="th" scope="row"><Skeleton animation="wave" /></TableCell>
                              <TableCell component="th" scope="row"><Skeleton animation="wave" /></TableCell>
                            </TableRow>
                          ))
                      )
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        )}
        {
          (modalHelp ?
            <HelpModal
              toggle={toggleModalHelp}
              modal={modalHelp}
              props={props}
              tela={MANUAIS_CATEGORIAS.ABA_ORDEM_SERVICO_FINANCEIRO}
            />
            :
            null
          )
        }
        {openEditValor && (
          <Dialog open={openEditValor} onClose={() => setOpenEditValor(false)} maxWidth="xs" fullWidth>
            <DialogTitle>Alterar Valor</DialogTitle>
            <DialogContent style={{ paddingTop: 10 }}>
              <TextField
                autoFocus
                margin="dense"
                label="Novo Valor (R$)"
                type="text"
                fullWidth
                variant="outlined"
                value={valorInput}
                onChange={(e) => setValorInput(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <CustomButton onClick={() => setOpenEditValor(false)} color="secondary">
                Cancelar
              </CustomButton>
              <CustomButton onClick={handleSaveEditValor} color="primary" variant="contained">
                Salvar
              </CustomButton>
            </DialogActions>
          </Dialog>
        )}
      </Grid>
    </>
  );
};

OrdemServicoFinanceiroEdit.propTypes = {
  classes: PropTypes.object.isRequired
}
const mapStateToProps = (state) => {
  return state
}

const connectedOrdemServicoFinanceiroEditPage = withRouter(
  connect(mapStateToProps, null, null)(withStyles(styles)(OrdemServicoFinanceiroEdit))
)
export { connectedOrdemServicoFinanceiroEditPage as OrdemServicoFinanceiroEdit }

export default OrdemServicoFinanceiroEdit;
